import { BaseService } from './base';
import { ApiRequest } from '../lib/request';
import type { ApiResponse } from '../lib/response';

import { ExportModel } from '../models/export';

export class ExportService extends BaseService<ExportModel> {
  override model = ExportModel;
  override modelName = 'export';
  override modelLabel = 'Export';

  async exporters(): Promise<ApiResponse<any>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/exporters`,
    });

    return await this.request(request);
  }

  async exportData({
    type,
    params = [],
  }: {
    type: string;
    params?: any[];
  }): Promise<ApiResponse<any>> {
    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}/export`,
      data: { type, params },
    });

    return await this.request(request);
  }

  async rerun(
    exportItem: ExportModel,
  ): Promise<ApiResponse<any>> {
    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}/export`,
      data: {
        type: exportItem.type,
        params: JSON.parse(exportItem.params),
      },
    });

    return await this.request(request);
  }
}
